module.exports = __webpack_public_path__ + "img/IconeEmail.0e031580.png";